/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/10/19
 * Time: 10:55 AM
 */
import * as actionTypes from '../Action/actionTypes';

const initialState = {
  image: []
};

const reducer=(state=initialState,action)=>{
  switch(action.type){

    case actionTypes.IMAGE_UPLOADER:
      return {
        ...state,
        image: action.value
      };

    default:
      return state;
  }
};

export default reducer;
